import { render, staticRenderFns } from "./TitleSetter.vue?vue&type=template&id=2c67ab25&"
import script from "./TitleSetter.vue?vue&type=script&lang=js&"
export * from "./TitleSetter.vue?vue&type=script&lang=js&"
import style0 from "./TitleSetter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TitleSetter.vue"
export default component.exports